import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import CheckoutAddressForm from "./components/CheckoutAddressForm";
import ValidationResult from "./components/ValidationResult";
import AddressLogs from "./components/AddressLogs";
import Settings from "./components/Settings";
import DashboardHome from "./components/DashboardHome";
//import AdminDashboard from "./pages/AdminDashboard";
import SubscriptionPage from "./pages/SubscriptionPage";

function App() {
  const [validationResult, setValidationResult] = React.useState(null);

  return (
    <Router>
      <div className="font-inter min-h-screen bg-gray-100">
        <Navbar />
        <div className="py-6 sm:py-8 px-4 sm:px-6 lg:px-8">
          <Routes>
            <Route
              path="/validate"
              element={
                <div className="max-w-7xl mx-auto">
                  <CheckoutAddressForm
                    onAddressValidated={setValidationResult}
                  />
                  <ValidationResult result={validationResult} />
                </div>
              }
            />
            <Route path="/plans" element={<SubscriptionPage />} />
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/logs" element={<AddressLogs />} />
            <Route path="/settings" element={<Settings />} />
            <Route
              path="/"
              element={
                <div className="max-w-7xl mx-auto">
                  <CheckoutAddressForm
                    onAddressValidated={setValidationResult}
                  />
                </div>
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
